import React, { useState, useEffect, useRef } from 'react';
import { gql, useQuery } from '@apollo/client';
import BarraNavegacion from './BarraNavegacion';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

const OBTENER_PESO = gql`
  query {
    pesoBascula
  }
`;

function GetProductosLegumbre() {
  const [carrito, setCarrito] = useState([]);
  const [total, setTotal] = useState(0);
  const [cantidades, setCantidades] = useState({});
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
  const cardRefs = useRef([]);

  const { data: productosData, loading: productosLoading, error: productosError } = useQuery(GET_PRODUCTOS);
  const { data: pesoData, loading: pesoLoading, error: pesoError } = useQuery(OBTENER_PESO, {
    pollInterval: 1000,
  });

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(carrito));
    recalcularTotal();
  }, [carrito]);

  const productosFiltrados = productosData?.getProductos
    ? productosData.getProductos
        .filter((producto) => producto.codigo === "1" || producto.codigo === "2")
        .sort((a, b) => a.nombre.localeCompare(b.nombre))
    : [];

  const agregarAlCarrito = (producto) => {
    let cantidad = cantidades[producto._id];

    if (!cantidad) {
      if (producto.codigo === "1" && pesoData?.pesoBascula) {
        cantidad = parseFloat(pesoData.pesoBascula); // en kg como decimal
      } else {
        cantidad = 1; // por unidad
      }
    }

    const productoEnCarrito = carrito.find((item) => item._id === producto._id);

    if (productoEnCarrito) {
      setCarrito((prevCarrito) =>
        prevCarrito.map((item) =>
          item._id === producto._id ? { ...item, cantidad: item.cantidad + cantidad } : item
        )
      );
    } else {
      setCarrito((prevCarrito) => [...prevCarrito, { ...producto, cantidad }]);
    }
  };

  const cambiarCantidadProducto = (productId, nuevaCantidad) => {
    setCantidades((prevCantidades) => ({
      ...prevCantidades,
      [productId]: nuevaCantidad,
    }));
  };

  const recalcularTotal = () => {
    const nuevoTotal = carrito.reduce((acc, producto) => {
      const subtotal =
        producto.codigo === "1"
          ? producto.precio * producto.cantidad + 300
          : producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };

  if (productosLoading || pesoLoading) return <p>Cargando datos...</p>;
  if (productosError) return <p>Error al cargar productos</p>;
  if (pesoError) return <p>Error al leer la báscula</p>;

  return (
    <div>
      <a className="btn-carrito btn" href="/">
        <FontAwesomeIcon icon={faShoppingCart} />
      </a>

      <p>
        <strong>Peso actual:</strong> {pesoData?.pesoBascula ?? 'No disponible'} kg
      </p>

      <div className="container">
        <div className="row">
          {productosFiltrados.map((producto, index) => {
            const cantidadMostrar =
              cantidades[producto._id] ??
              (producto.codigo === "1" && pesoData?.pesoBascula ? parseFloat(pesoData.pesoBascula) : 0.01);

            return (
              <div
                className={`card-legumbre col-2 ${indiceSeleccionado === index ? 'seleccionado' : ''}`}
                key={producto._id}
                ref={(el) => (cardRefs.current[index] = el)}
              >
                <div className="card-body">
                  <h6 className="card-title">{producto.nombre}</h6>
                  <p className="card-text">
                    <img src={producto.imagen} width="35px" alt={producto.nombre} />
                    ${producto.codigo === "1" ? (producto.precio  + 300).toFixed(0) : producto.precio.toFixed(0)}
                  </p>
                  <p>Cantidad: {cantidadMostrar} {producto.codigo === "1" ? 'kg' : 'u'}</p>
                  <button
                    className="btn btn-primary btn-legumbre"
                    onClick={() => agregarAlCarrito(producto)}
                  >
                    Agregar
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <h2>Total a pagar: ${total.toFixed(2)}</h2>
      </div>
    </div>
  );
}

export default GetProductosLegumbre;
